/* global dataSourceLookups */

import { ItemListingState } from "./listing-helper";

const state = ItemListingState;

/**
 * Builds lookups for filters.
 */
class CacheHandler {

	constructor() {
		this.cache = {};
		this.resetCache();
		this.buildCache();
	}

	resetCache() {
		this.cache.dataSourceById = {};
		this.cache.optionsLookup = {};
		this.cache.groupLookup = {};
		this.cache.viewRenderData = {};
	}

	/**
	 * Creates lookups for easier data handling and rendering.
	 */
	buildCache() {

		const sortKeys = [];
		for (const key of Object.keys(state.dataSourceWorkset)) {
			this.cache.viewRenderData[key] = [];

			const filtersGroups = {};
			for (const filterValue of state.dataSourceWorkset[key]) {

				if (filterValue.typeGroup && filtersGroups[filterValue.typeGroup] === undefined) {
					filtersGroups[filterValue.typeGroup] = [];
				} else if (filtersGroups.noGroup === undefined) {
					filtersGroups.noGroup = [];
				}
				if (filterValue.typeGroup) {
					filtersGroups[filterValue.typeGroup].push(filterValue);
				} else {
					filtersGroups.noGroup.push(filterValue);
				}
			}

			for (const fkey of Object.keys(filtersGroups)) {
				if (filtersGroups[fkey].length > 0) {
					const filterValues = { typeGroup: fkey, dataSource: key, typeGroupName: dataSourceLookups.groupNames[fkey] || fkey, filterValues: filtersGroups[fkey] };

					for (const filter of filtersGroups[fkey]) {
						if (filter.id && filter.typeGroup) {
							sortKeys.push(key);
							this.cache.groupLookup[filter.id] = filter.typeGroup;
						}
					}

					this.cache.viewRenderData[key].push(filterValues);
				}
			}

			for (const key of Object.keys(this.cache.viewRenderData)) {
				const viewData = this.cache.viewRenderData[key];
				if (Array.isArray(viewData) && viewData.length === 1) {
					// Remove grouping if there"s only one group.
					delete viewData[0].typeGroup;
					delete viewData[0].typeGroupName;
				}
			}
		}

		for (const sortKey of sortKeys) {
			this.cache.viewRenderData[sortKey].sort((a, b) => dataSourceLookups.groupNamesOrder.indexOf(a.typeGroup) - dataSourceLookups.groupNamesOrder.indexOf(b.typeGroup));
		}

		const dataSourceToIdsMapper = () => {
			if (state.dataSourceWorkset) {
				for (const key of Object.keys(state.dataSourceWorkset)) {
					const arr = state.dataSourceWorkset[key];

					this.cache.dataSourceById[key] = {};

					for (const obj of arr) {
						const id = (obj.id) ? obj.id : obj.option;

						if (obj.values) {
							for (const subObj of obj.values) {
								subObj.optionsGroup = id;
								const subId = (subObj.id) ? subObj.id : subObj.option;
								this.cache.dataSourceById[key][subId] = subObj;
							}
						} else {
							this.cache.dataSourceById[key][id] = obj;
						}

					}

				}

			}
		};

		const optionsToIdsMapper = () => {
			if (state.dataSourceWorkset.options !== undefined && state.dataSourceWorkset.options.length > 0) {
				for (const element of state.dataSourceWorkset.options) {
					this.cache.optionsLookup[element.id] = element;
				}
			}
		};

		dataSourceToIdsMapper();
		optionsToIdsMapper();
	}
}

global.CacheHandler = global.CacheHandler || new CacheHandler();

export default global.CacheHandler;